import React, {useState, useRef} from 'react';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {useNavigate} from 'react-router-dom';
import BaseTable from 'components/tables/BaseTable';
import {useListSAMMeetingsQuery, useDeleteSAMMeetingMutation} from "../../apis/samApi";
import {DateTime} from "luxon";
import {Checkbox} from "primereact/checkbox";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Toast } from 'primereact/toast';


const SAMMeetingTable = () => {
    const navigate = useNavigate();
    const {data: meetings, isFetching} = useListSAMMeetingsQuery();
    const [showCompleted, setShowCompleted] = useState(false);
    const {data: userProfile} = useUserProfileQuery();
    const canEdit = userProfile?.company?.role === "CompanyOwner";
    const newMeeting = canEdit? ()  => edit("new") : undefined;
    const [deleteSAMMeeting] = useDeleteSAMMeetingMutation();
    const toast = useRef(null);

    const edit = (id) => {
        navigate(`/company-admin/shared-action-meetings/edit-meeting/${id}`);
    }
    const editAgenda = (id) => {
        navigate(`/company-admin/shared-action-meetings/edit-agenda/${id}`);
    }

    const deleteEntry = (id, event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Are you sure you want to proceed? All the associated tasks of the Shared Action Meeting will be deleted as well.',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteSAMMeeting(id)
        });
    }

    const actionTemplate = (rowData) => {
        return (
            <>
                {!rowData.completed && (<Button type="button" icon={"pi " +  (canEdit? "pi-pencil" : "pi-eye")} onClick={() => edit(rowData.id)} />)}
                <Button type="button" icon="pi pi-calendar" onClick={() => editAgenda(rowData.id)} />
            </>
        );
    }

    const removeTemplate = (rowData) => {
        return (
            <Button type="button" icon="pi pi-times" className='remove' rounded  onClick={(e) => deleteEntry(rowData.id, e)} />
        );
    }

    const meetingTimestampTemplate = (rowData) => {
        return DateTime.fromMillis(rowData.meetingTimestamp).toISODate()
    }

    const startTimeTemplate = (rowData) => {
        return DateTime.fromMillis(rowData.completed ? rowData.actualStartTimestamp : rowData.scheduledStartTimestamp).toLocaleString(DateTime.TIME_SIMPLE)
    }

    const endTimeTemplate = (rowData) => {
        return DateTime.fromMillis(rowData.completed ? rowData.actualEndTimestamp : rowData.scheduledEndTimestamp).toLocaleString(DateTime.TIME_SIMPLE)
    }

    const completedTemplate = (rowData) => {
        return rowData.completed ? (<i className="pi pi-check-square"></i>) : (<i className="pi pi-clock"></i>)
    }

    const renderTitleExtras = () => {
        return (
            <div className="show-completed-meetings">
                <Checkbox inputId="show-completed" checked={showCompleted} onChange={e => setShowCompleted(e.checked)} />
                <label htmlFor="show-completed">Show Completed Meetings</label>
            </div>
        )
    }

    return (
        <>
            <Toast ref={toast} />
            <ConfirmPopup />
            <BaseTable
                title="Shared Action Meetings"
                titleExtras={renderTitleExtras()}
                isLoading={isFetching}
                createNew={newMeeting}
                emptyMessage="No meetings found."
                dataList={(meetings || []).filter(meeting => showCompleted || !meeting.completed)}
                rows={5}>
                <Column field="completed" style={{width: '3rem'}} body={completedTemplate} />
                <Column field="meetingTimestamp" header="Shared Action Meeting" body={meetingTimestampTemplate} />
                <Column field="startTimestamp" style={{width: '10rem'}} header="Start Time" body={startTimeTemplate} />
                <Column field="endTimestamp" style={{width: '10rem'}} header="End Time" body={endTimeTemplate} />
                <Column className="action-column" headerClassName="centered-header" bodyClassName="p-text-center" header="Meeting Details" body={actionTemplate} />
                { canEdit && <Column className="action-column" headerClassName="centered-header" bodyClassName="p-text-center" header="" body={removeTemplate} />}
            </BaseTable>
        </>
    )
}

export default SAMMeetingTable;